import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { dateObjectFormatter } from 'global/helperFunctions/dateFormatter';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IOrderSummeryDetail {
  orderMethods: orderMethodsState;
}

const OrderSummeryDetail: FC<IOrderSummeryDetail> = ({ orderMethods }) => {
  //states
  const { deliveryTypes, pickupTypes } = useSelector((state: RootState) => state.parcelOrder);

  return (
    <div className='grid grid-cols-1 gap-2 md:grid-cols-2'>
      <div className='flex items-center gap-2'>
        <span className='text-sm text-t-secondary-text-color'>جمع آوری :</span>
        {pickupTypes && orderMethods.pickupTypeId && <span>{pickupTypes.find((item) => orderMethods.pickupTypeId === item.id)?.title}</span>}
      </div>
      <div className='flex items-center gap-2'>
        <span className='text-sm text-t-secondary-text-color'>زمان جمع آوری :</span>
        <span>
          {dateObjectFormatter(orderMethods.selectedDate, 'dddd DD MMMM YYYY')} - {orderMethods.selectedFromHour} تا {orderMethods.selectedToHour}
        </span>
      </div>
      <div className='flex items-center gap-2'>
        <span className='text-sm text-t-secondary-text-color'>توزیع :</span>
        {deliveryTypes && orderMethods.deliveryTypeId && <span>{deliveryTypes.find((item) => orderMethods.deliveryTypeId === item.id)?.title}</span>}
      </div>
    </div>
  );
};

export default OrderSummeryDetail;
